export default __webpack_public_path__ + "static/media/Personaje_Banner_Garantia-555x650.941e80ff.webp";